import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { environment } from './../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class EnvService {

  API_URL = environment.API_URL;
  APP_NAME = 'fathom';
  VERSION = '2.0.5';

  //
  // e.g. {endpoint:'templates', doctype:'templates'}
  //
  syncConfig: any = {
    defaultSyncSettings: { timestamps:{}, nextSync:{}, syncLast: 0, syncFrequency:'1 hour', syncStrategy: 'doc'  },
    notificationDocs: [{endpoint:'notifications', doctype:'template', syncFrequency:'4 hours'}],
    dataDocs: [{endpoint:'userdata',doctype:'car'}],
  }

  global:any = {};
  deviceInfo:any = {};

  constructor() 
  { 
    this.getDeviceInfo();
  }


  async getDeviceInfo()
  {
    this.deviceInfo = await Device.getInfo();
  }

}
